import React from 'react';
import { useMaintenanceBanner } from 'src/hooks/useMaintenanceBanner';
import MaintenanceBannerView from 'src/components/layouts/MaintenanceBanner/MaintenanceBannerView';
import { MaintenanceContext } from 'src/services/maintenanceState';

export interface MaintenanceBannerProps {
  /** `login` shows the generic "not reachable" notice as well; the portal leaves that to the pages. */
  context: MaintenanceContext;
}

/** Maintenance notice for the top of the login screen and of the signed-in portal. */
const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ context }) => {
  const { state, dismiss } = useMaintenanceBanner(context);
  return <MaintenanceBannerView state={state} context={context} onDismiss={dismiss} />;
};

export default MaintenanceBanner;
